import React from 'react'
import { schloarImg } from '../../assets/index'

const Scholarship = () => {
    return (
        <>

            <div className='relative top-[5rem]'>

                  <div className='relative top-[3rem] mb-4'>
                    <div className="w-full h-[20rem]  ">
                        <div className="w-full h-[20rem] bg-orange-500"></div>
                    </div>

                    <div className="w-[90%] sm:w-[85%] md:w-[80%] lg:w-[70rem] h-auto bg-white mx-auto relative bottom-60 rounded-2xl p-4 sm:p-8">
                        <div className="flex flex-col lg:flex-row items-center lg:items-start">
                            <div className="relative lg:top-[5rem] lg:left-[5rem] text-center lg:text-left mb-8 lg:mb-0">
                                <p className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl relative text-violet-950">
                                    Get up to
                                </p>
                                <p className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-violet-950">
                                    SCHOLARSHIP
                                </p>
                            </div>
                            <img
                                src={schloarImg}
                                className="w-[15rem] sm:w-[18rem] md:w-[22rem] lg:w-[25rem] h-[12rem] sm:h-[15rem] md:h-[18rem] lg:h-[20rem] 
            relative lg:right-[-8rem] lg:bottom-8 mt-4 lg:mt-0"
                            />
                        </div>
                    </div>
                </div>   

                <div className="text-justify max-w-full overflow-x-hidden flex-row relative">
                    <div className='relative bottom-[2rem]'>
                        <div className="w-96 max-w-[100px] bg-orange-500 h-1 mx-0 my-5 relative top-3 left-8 sm:left-16 md:left-24 lg:left-32 xl:left-36"></div>

                        <p className="text-orange-500 font-semibold text-2xl sm:text-3xl md:text-4xl relative -top-1 left-6 sm:left-14 md:left-20 lg:left-28 xl:left-32 mx-0 px-4">
                            Scholarship
                        </p>
                    </div>

                    <p className="text-justify w-11/12 sm:w-10/12 md:w-9/12 lg:w-10/12 h-auto text-base sm:text-lg md:text-xl relative left-8 sm:left-16 md:left-24 lg:left-32 xl:left-36 mb-8">
                        We offer Scholarships to outstanding candidates whose profiles will help FBS, Pune, promote Value-based Leadership and Best Business practices in the field of Management Education, particularly by ensuring diversity. For more information about scholarships, you may contact our admission counsellors.
                    </p>


                    <div className="flex flex-col items-center w-full relative mb-4" style={{marginBottom:'6rem'}}>
                        <div className="text-center my-4">
                            <p className="text-xl sm:text-2xl font-semibold text-purple-950 relative bottom-2">
                                Come Back <span className="text-2xl sm:text-4xl font-bold">
                                    STRONGER
                                </span>
                                <t> in </t><span className="text-2xl sm:text-4xl font-bold">
                                    MBA Finance
                                </span>
                            </p>
                        </div>
                        <span className="text-2xl sm:text-3xl md:text-4xl font-bold text-purple-950 text-center px-4 sm:px-0  relative bottom-2">
                            Appear for instant Admission and Scholarship Test.
                        </span>
                    </div>
                </div>
               
            </div>


        </>
    )
}

export default Scholarship